import React from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'
import cleanDeep from 'clean-deep';
import { usePaginatedQuery } from 'react-query'
import { Spacer } from 'components/atoms'
import { InputIcon, Pagination } from 'components/molecules'
import { PeopleTableSelect } from 'components/organisms'
import { getAllUsers, SUBWEB_USERS_ALL_KEY } from 'services/requests'
import { useDebounce } from 'react-use'

const PeopleSelect = ({
  subweb,
  pageId,
  onSelect,
}) => {
  const [search, setSearch] = React.useState('')
  const [debouncedSearch, setDebouncedSearch] = React.useState('');
  const [page, setPage] = React.useState(1)

  useDebounce(
    () => {
      if (debouncedSearch !== search) setDebouncedSearch(search);
    },
    350,
    [search]
  );

  const {
    isLoading,
    isFetching,
    resolvedData,
  } = usePaginatedQuery([SUBWEB_USERS_ALL_KEY, {
    subweb,
    currentPage: page,
    search: debouncedSearch,
    filter: pageId ? 'page' : 'service',
    pageId,
  }], getAllUsers)

  const totalRecords = React.useMemo(
    () => (
      resolvedData && resolvedData.data
        && resolvedData.data.pagination && resolvedData.data.pagination.totalRecords
        ? resolvedData.data.pagination.totalRecords
        : 0
    ),
    [resolvedData])

  const dataComputed = React.useMemo(() => {
    if (
      resolvedData && resolvedData.data && resolvedData.data.data
        && resolvedData.data.data.length > 0
    ) {
      return resolvedData.data.data.map(({
        id,
        email,
        name,
      }) => {
        const person = {
          id,
          name,
          email: email.length >= 1 ? email[0] : null,
        }
        return cleanDeep(person)
      })
    }
    return []
  }, [resolvedData])

  const handleSearch = (e) => {
    const searchValue = e.target.value
    setSearch(searchValue)
    setPage(1)
  }

  // react-table pages start at 0 while rc-pagination starts at 1
  const tablePage = React.useMemo(() => page - 1, [page])

  return (
    <>
      <Top>
        <InputIcon
          isLoading={isLoading || isFetching}
          icon="search"
          placeholder="pesquisar pessoas"
          value={search}
          onChange={handleSearch}
          modifiers={['stretch']}
        />
      </Top>
      <List>
        <Spacer bottom="m">
          <Pagination
            onChange={(nextPage) => setPage(nextPage)}
            current={page}
            total={totalRecords}
          />
        </Spacer>
        <PeopleTableSelect
          data={dataComputed}
          page={tablePage}
          loading={isLoading}
          onSelect={onSelect}
        />
        <Spacer top="m">
          <Pagination
            onChange={(nextPage) => setPage(nextPage)}
            current={page}
            total={totalRecords}
          />
        </Spacer>
      </List>
    </>
  )
}

const Top = styled.div`
  width: 100%;
  padding-bottom: ${props => props.theme.spacing.l};
`;

const List = styled.div``

PeopleSelect.propTypes = {
  subweb: PropTypes.string.isRequired,
  pageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func,
}

PeopleSelect.defaultProps = {
  pageId: undefined,
  onSelect: () => null,
}

export default PeopleSelect
